var _defs, _rect, _circle, _circle2, _g, _text, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgentforcecc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 360,
    viewBox: "0 0 640 360",
    role: "img",
    "aria-label": "Agentforce for Community Cloud",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b2e4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a1e0"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "url(#bg2)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 300,
    r: 120,
    fill: "#ffffff",
    opacity: 0.08
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 60,
    r: 90,
    fill: "#ffffff",
    opacity: 0.08
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60,96)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 150,
    height: 150,
    rx: 26,
    fill: "#ffffff",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 94,
    textAnchor: "middle",
    fontFamily: "Montserrat, Arial, sans-serif",
    fontSize: 58,
    fontWeight: 800,
    fill: "#ffffff"
  }, "\u26A1"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 140,
    fontFamily: "Montserrat, Arial, sans-serif",
    fontSize: 36,
    fontWeight: 800,
    fill: "#ffffff"
  }, "Agentforce for")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 184,
    fontFamily: "Montserrat, Arial, sans-serif",
    fontSize: 36,
    fontWeight: 800,
    fill: "#ffffff"
  }, "Experience Cloud")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 226,
    fontFamily: "Montserrat, Arial, sans-serif",
    fontSize: 21,
    fill: "#cfe9f7"
  }, "Self-service AI quoting for portal users")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentforcecc);
export default __webpack_public_path__ + "static/media/agentforcecc.404e7295ef739dec262f1ad2f1b7f262.svg";
export { ForwardRef as ReactComponent };